import { Injectable } from '@angular/core';
import { UserService } from './user-service';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { Branch } from '../models/entities/control-tables/branch-entity';
import { BranchRequest } from '../models/dtos/control-tables/branch-request';
import { Profile } from '../models/entities/master-data/profile-entity';
import { Result } from '../models/entities/result';
import { Bank } from '../models/entities/control-tables/bank';
import { BankRequest } from '../models/dtos/control-tables/bank-request';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { GeoArea } from '../models/entities/control-tables/geo-area-entity';



@Injectable({
  providedIn: 'root'
})
export class ControlTablesService {

  constructor(
    public userService : UserService,
    private networkService : LeanNetworkService) { }


//------------------------------------------------------------------------------------
//                      BRANCH
//------------------------------------------------------------------------------------

  branches : Branch[];
  branchsGet(code? : string, name?  :string): Promise<Branch[]> {
    let request         : BaseRequest = new BaseRequest(this.userService.userInfo);

    request.strArg1 = code;
    request.strArg2 = name;
    
    return new Promise((resolve, reject) => {
        if (this.branches) return resolve(this.branches);
        this.networkService.post('kernel/controls/branchsGet', request).then(result => {
          this.branches = result.branchs;
          return resolve(this.branches);
        }, error => {
            reject(error);
        });
    });
  }

  branchSave(branch : Branch) : Promise<Branch>{
    let request: BranchRequest = new BranchRequest(this.userService.userInfo);
    request.branch = branch;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/controls/branchSave', request).then(result => {
            let branch : Branch  = result.branch;
            return resolve(branch);         
        }, error => {
            reject(error);
        });
    });
}
//------------------------------------------------------------------------------------



//------------------------------------------------------------------------------------
//                        PROFILE
//------------------------------------------------------------------------------------
profiles : Profile[];
profilesGet(code: string, name : string): Promise<Profile[]> {
  let request: BaseRequest = new BaseRequest(this.userService.userInfo);

  request.strArg1 = code;
  request.strArg2 = name;

  return new Promise((resolve, reject) => {
    if (this.profiles) return resolve(this.profiles);
      this.networkService.post('kernel/controls/profilesGet', request).then(result => {
        this.profiles = result.profiles;
          return resolve(this.profiles);
      }, error => {
          reject(error);
      });
  });
}
//------------------------------------------------------------------------------------



//------------------------------------------------------------------------------------
//                        BANK
//------------------------------------------------------------------------------------
banks : Bank[];
banksGet(code : string, name : string): Promise<Bank[]> {
  let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
  request.strArg1 = code;
  request.strArg2 = name;
  
  return new Promise((resolve, reject) => {
    if (this.banks) return resolve(this.banks);
      this.networkService.post('kernel/controls/banksGet', request).then(result => {
        this.banks = result.banks;
        return resolve(this.banks);
      }, error => {
          reject(error);
      });
  });
}

bankSave(bank : Bank) : Promise<Bank>{
  let request: BankRequest = new BankRequest(this.userService.userInfo);
  request.bank = bank;

  return new Promise((resolve, reject) => {
      this.networkService.post('kernel/controls/bankSave', request).then(result => {
          let bank : Bank = result.bank;
          return resolve(bank);         
      }, error => {
          reject(error);
      });
  });
}
//------------------------------------------------------------------------------------

    
//------------------------------------------------------------------------------------
//   GEO AREA
//------------------------------------------------------------------------------------
personGeoAreaGet(): Promise<GeoArea> {
  let request: BaseRequest = new BaseRequest(this.userService.userInfo);

  return new Promise((resolve, reject) => {
      this.networkService.post('kernel/controls/personGeoAreaGet', request).then(result => {
          return resolve(result.geoArea);
      }, error => {
          reject(error);
      });
  });
}
//------------------------------------------------------------------------------------




//------------------------------------------------------------------------------------
//                        GENERIC
//------------------------------------------------------------------------------------
getList(entityName : string, request : BaseRequest, path? : string):Promise<any[]>{
  if (! path) path = "kernel/controls/" ;
  let serviceData : Result = this.getServiceData(entityName, path);
  return new Promise((resolve, reject) => {
    this.networkService.post(serviceData.urlGetList, request).then(result => {
      return resolve(result[serviceData.listFieldName]);
    }, error => {
        reject(error);
    });
});
}
getSingle(entityName : string, request : BaseRequest, path? : string):Promise<any>{
  if (! path) path = "kernel/controls/" ;
  let serviceData : Result = this.getServiceData(entityName, path);
  return new Promise((resolve, reject) => {
    this.networkService.post(serviceData.urlGetSingle, request).then(result => {
      return resolve(result[serviceData.entityFieldName]);
    }, error => {
        reject(error);
    });
});
}

save(entityName : string, request : any, path? : string):Promise<any>{
  if (! path) path = "kernel/controls/" ;
  let serviceData : Result = this.getServiceData(entityName, path);

  return new Promise((resolve, reject) => {
      this.networkService.post(serviceData.urlSave, request).then(result => {
          return resolve(result[entityName]);
      }, error => {
          reject(error);
      });
  });
}


getServiceData(entity: string, path : string) : Result{
  let urlGetList      = path + entity + "sGet";
  let urlGetSingle    = path + entity + "Get";
  let urlSave         = path + entity + "Save";
  let listFieldName   = entity + "s";
  let entityFieldName = entity ;
  return new Result(urlGetList, urlGetSingle, urlSave, listFieldName, entityFieldName);
}

getRequest(){
  return new BaseRequest(this.userService.userInfo);
}

getUserInfo(){
  return this.userService.userInfo;
}


}

